import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "timeline-container" }
const _hoisted_2 = { class: "timeline" }
const _hoisted_3 = { class: "timeline__epochs" }

import EpochVRAK from "../epoch/EpochVRAK.vue";

import { useTimelineData } from "@features/Pages/TimelineMapPage/_js/app/composables/vrak/useTimelineData";
import { useEpochToggle } from "@features/Pages/TimelineMapPage/_js/app/composables/vrak/useEpochToggle";
import { useTimelineEffects } from "@features/Pages/TimelineMapPage/_js/app/composables/vrak/useTimelineEffects";


export default /*@__PURE__*/_defineComponent({
  __name: 'TimelineVRAK',
  setup(__props) {

const { epochs, translations } = useTimelineData();

const { onToggleEpoch } = useEpochToggle(translations);

useTimelineEffects();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "timeline__history-line" }, null, -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(epochs), (epoch) => {
          return (_openBlock(), _createBlock(EpochVRAK, {
            key: epoch.id,
            epoch: epoch,
            translations: _unref(translations),
            onToggleEpoch: _unref(onToggleEpoch)
          }, null, 8 /* PROPS */, ["epoch", "translations", "onToggleEpoch"]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
}
}

})